import { withNamespaces } from 'react-i18next';

import { CyberSecurityStatuses } from '../../constants';

const CategoryChecks = ({
    category,
    onSelectCheck,
    selectedCheckId,
    t,
}) => {
    const status = CyberSecurityStatuses[category.status];
    const passedCount = category.checks.filter((check) => check.status === 'passed').length;

    return (
        <div>
            <div className="d-flex align-items-start gap-3 mb-4">
                <span className={`cyber-nav-icon is-${category.iconColor}`}>
                    <i className={category.icon} />
                </span>
                <div className="flex-grow-1">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                        <h5 className="mb-0">{t(category.title)}</h5>
                        <span className="font-size-12">
                            <span className={status.className}>
                                <i className={`${status.icon} align-middle me-1`} />
                                {t(status.title)}
                            </span>
                            <span className="text-muted ms-2">
                                {`${passedCount} / ${category.checks.length} ${t('checks passed')}`}
                            </span>
                        </span>
                    </div>
                    <p className="text-muted mb-0 mt-1">{t(category.description)}</p>
                </div>
            </div>

            {!category.checks.length && (
                <p className="text-muted">{t('No checks available for this category.')}</p>
            )}

            {category.checks.map((check) => {
                const checkStatus = CyberSecurityStatuses[check.status];

                return (
                    <button
                        className={`cyber-check ${selectedCheckId === check.id ? 'is-active' : ''}`}
                        key={check.id}
                        onClick={() => onSelectCheck(check)}
                        type="button"
                    >
                        <i className={`${checkStatus.icon} ${checkStatus.className}`} />
                        <span className="flex-grow-1 text-start">
                            <span className="d-block fw-medium">{t(check.title)}</span>
                            <span className="d-block font-size-12 text-muted">{t(check.summary)}</span>
                        </span>
                        <i className="ri-arrow-right-s-line text-muted" />
                    </button>
                );
            })}

            {category.whyItMatters && (
                <div className="cyber-note mt-3">
                    <i className="ri-information-line text-primary" />
                    <div>
                        <div className="fw-medium mb-1">{t('Why this matters')}</div>
                        <p className="text-muted mb-0">{t(category.whyItMatters)}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default withNamespaces()(CategoryChecks);
